import React from "react"

function Expertise(){
return(
    <h1>hi</h1>
)
}


export default Expertise